import { createFileRoute } from "@tanstack/react-router";
import ExcellusBcbsInsurance, { config } from "@/pages/ExcellusBcbsInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/excellus-bcbs-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Excellus BCBS TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Excellus BlueCross BlueShield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Excellus BCBS TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Excellus BlueCross BlueShield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/excellus-bcbs-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/excellus-bcbs-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ExcellusBcbsInsurance />;
}
